module.exports = __webpack_public_path__ + "static/media/infoOutlined.444d909c.svg";